module.exports = __webpack_public_path__ + "img/tuurro.t6.bar.02d712a3.png";